<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="8" offset-md="2">
        <v-card>
          <v-card-title>
            <v-btn 
              icon="mdi-arrow-left"
              variant="text" 
              @click="$router.push('/lists')"
              class="mr-2"
            ></v-btn>
            <v-icon left>mdi-account</v-icon>
            Profile Settings
          </v-card-title>
          
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <h3>Account Information</h3>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>Username</v-list-item-title>
                    <v-list-item-subtitle>{{ authStore.user?.username }}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Member Since</v-list-item-title>
                    <v-list-item-subtitle>{{ formatDate(authStore.user?.created_at) }}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              
              <v-col cols="12" md="6">
                <h3>Change Password</h3>
                <v-form ref="passwordForm" v-model="passwordValid" @submit.prevent="changePassword">
                  <v-text-field
                    v-model="currentPassword"
                    :rules="currentPasswordRules"
                    label="Current Password"
                    type="password"
                    required
                  ></v-text-field>
                  
                  <v-text-field
                    v-model="newPassword"
                    :rules="newPasswordRules"
                    label="New Password"
                    type="password"
                    required
                  ></v-text-field>
                  
                  <v-text-field
                    v-model="confirmNewPassword"
                    :rules="confirmNewPasswordRules"
                    label="Confirm New Password"
                    type="password"
                    required
                  ></v-text-field>
                  
                  <v-btn
                    color="primary"
                    :disabled="!passwordValid || passwordLoading"
                    :loading="passwordLoading"
                    @click="changePassword"
                  >
                    Change Password
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { ref } from 'vue'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'Profile',
  setup() {
    const authStore = useAuthStore()
    
    const passwordValid = ref(false)
    const passwordLoading = ref(false)
    const currentPassword = ref('')
    const newPassword = ref('')
    const confirmNewPassword = ref('')
    const snackbar = ref(false)
    const snackbarText = ref('')
    const snackbarColor = ref('error')
    
    const currentPasswordRules = [
      v => !!v || 'Current password is required'
    ]
    
    const newPasswordRules = [
      v => !!v || 'New password is required',
      v => v.length >= 6 || 'Password must be at least 6 characters'
    ]
    
    const confirmNewPasswordRules = [
      v => !!v || 'Password confirmation is required',
      v => v === newPassword.value || 'Passwords must match'
    ]
    
    const formatDate = (dateString) => {
      if (!dateString) return ''
      return new Date(dateString).toLocaleDateString()
    }
    
    const showMessage = (message, color = 'error') => {
      snackbarText.value = message
      snackbarColor.value = color
      snackbar.value = true
    }
    
    const changePassword = async () => {
      if (!passwordValid.value) return
      
      passwordLoading.value = true
      
      try {
        const result = await authStore.changePassword({
          current_password: currentPassword.value,
          new_password: newPassword.value
        })
        
        if (result.success) {
          showMessage('Password changed successfully!', 'success')
          currentPassword.value = ''
          newPassword.value = ''
          confirmNewPassword.value = ''
        } else {
          showMessage(result.error)
        }
      } catch (error) {
        showMessage('An error occurred. Please try again.')
      } finally {
        passwordLoading.value = false
      }
    }
    
    return {
      authStore,
      passwordValid,
      passwordLoading,
      currentPassword,
      newPassword,
      confirmNewPassword,
      currentPasswordRules,
      newPasswordRules,
      confirmNewPasswordRules,
      snackbar,
      snackbarText,
      snackbarColor,
      formatDate,
      changePassword
    }
  }
}
</script>